import { Schema } from 'prosemirror-model';
import { schema } from 'ngx-editor';

const heading = schema.spec.nodes.get('heading')!;

// Clipboard context can bypass the DOM parser and supply attributes directly.
// The heading level determines a DOM tag, so only the six HTML levels are valid.
export const noteEditorSchema = new Schema({
  nodes: schema.spec.nodes.update('heading', {
    ...heading,
    attrs: {
      ...heading.attrs,
      level: {
        ...heading.attrs?.['level'],
        validate: (value: unknown) => {
          if (
            typeof value !== 'number' ||
            !Number.isInteger(value) ||
            value < 1 ||
            value > 6
          ) {
            throw new RangeError('Invalid note heading level.');
          }
        },
      },
    },
  }),
  marks: schema.spec.marks,
});
